import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';

import { createRootReducer } from 'reducers';

export const history = createBrowserHistory();
export let store = null;

export const init = (additionalMiddleware = [], history) => {
  const middleware = getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: {
      // Ignore these action types
      ignoredActions: ['@@router/LOCATION_CHANGE', 'update-user-error'],
      // Ignore these field paths in all actions
      ignoredActionPaths: [],
      // Ignore these paths in the state
      ignoredPaths: ['router', 'user.error'],
    },
  });

  if (additionalMiddleware.length > 0) {
    middleware.push(...additionalMiddleware);
  }

  store = configureStore({
    reducer: createRootReducer(history),
    middleware,
  });

  return store;
};
